module.exports = __webpack_public_path__ + "static/media/42.ac29d349.jpg";